
/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class EditScaffoldSpecificationCommand {
  ScaffoldId: string;
  HandoverId: string;
  ScaffoldItemId: string;
  ScaffoldTypeId: string;
  ScaffoldTypeFurtherInformation: string;
  Description: string;
  QuoteNumber: string;
  QuoteItemNumber: string;
  QuoteItemName: string;
  DesignTypeId: string;
  DesignTypeFurtherInformation: string;
  LoadingLimitId: string;
  LoadingLimitFurtherInformation: string;
  MethodOfTyingId: string;
  MethodOfTyingFurtherInformation: string;
  MethodOfCladdingId: string;
  MethodOfCladdingFurtherInformation: string;
  HirePeriod: number;
  ScaffoldingSystemId: string;
  MaximumTonnage: number;
  StandingTonnage: number;
  CommandVersion: string;
  SourceApp: string;
  SourceAppVersion: string;
}


